
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const ReagentNotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="container mx-auto px-4 py-16 flex-grow text-center">
        <h1 className="text-3xl font-bold mb-4">Reagent Not Found</h1>
        <p className="text-gray-600 mb-6">
          The reagent you are looking for could not be found.
        </p>
        <Button asChild>
          <Link to="/reagents">Browse All Reagents</Link>
        </Button>
      </div>
      <Footer />
    </div>
  );
};

export default ReagentNotFound;
